import APIClient from "../APIClient";

import {
  LOAD_MESSAGES_SUCCESS,
  LOAD_MESSAGE_TEMPLATE_SUCCESS,
  LOAD_MESSAGE_TEMPLATE_ERROR,
  MESSAGE_READ_SUCCESS,
  MESSAGE_UNREAD_SUCCESS,
  LOAD_MESSAGE_UNREAD_COUNT_SUCCESS,
  PENDING_SEND_MESSAGE_SUCCESS,
  PENDING_MESSAGE_DELETED_SUCCESS,
  NEW_MESSAGE_RECEIVED,
  CURRENT_MESSAGE_DOCUMENT_IDS_UPDATED,
} from "./types";

const messageTemplateLoadSuccess = (appID, messageTemplate, templateName) => ({
  appID,
  messageTemplate,
  templateName,
  type: LOAD_MESSAGE_TEMPLATE_SUCCESS,
});

const messageTemplateLoadError = (appID, errorDetail, missingFields) => ({
  appID,
  errorDetail,
  missingFields,
  type: LOAD_MESSAGE_TEMPLATE_ERROR,
});

const pendingMessageSendSuccess = (appID, payload) => ({
  appID,
  payload,
  type: PENDING_SEND_MESSAGE_SUCCESS,
});

const messageLoadSuccess = (appID, messages) => ({
  appID,
  messages,
  type: LOAD_MESSAGES_SUCCESS,
});

const messageReadSuccess = (appID, messageReadRecord) => ({
  appID,
  messageReadRecord,
  type: MESSAGE_READ_SUCCESS,
});

const messageUnreadSuccess = (appID, messageUnreadRecord) => ({
  appID,
  messageUnreadRecord,
  type: MESSAGE_UNREAD_SUCCESS,
});

const messageUnreadCountSuccess = (appID, unreadCount) => ({
  appID,
  unreadCount,
  type: LOAD_MESSAGE_UNREAD_COUNT_SUCCESS,
});

const pendingMessageDeletedSuccess = (appID, jobID) => ({
  appID,
  jobID,
  type: PENDING_MESSAGE_DELETED_SUCCESS,
});

const newMessageReceived = (appID, message) => ({
  appID,
  message,
  type: NEW_MESSAGE_RECEIVED,
});

const docIDsUpdated = (appID, docIDs) => ({
  appID,
  docIDs,
  type: CURRENT_MESSAGE_DOCUMENT_IDS_UPDATED,
});

export const messageReceived = (appID: number, message: any) => dispatch => {
  dispatch(newMessageReceived(appID, message));
  dispatch(getUnreadMessageCount(appID));
};

export const updateDocIDsForCurrentMessage = (appID: number, docIDs: number[]) => dispatch => {
  dispatch(docIDsUpdated(appID, docIDs));
};

const sendMessage = (
  appID: number,
  message: string,
  docIDs: string[],
  templateName: string,
  isOperator: boolean,
) => dispatch => {
  const payload: {
    message: string;
    document_ids: string[];
    application_id?: number;
    template_name?: string;
  } = {
    message,
    document_ids: docIDs,
  };

  if (isOperator) {
    payload.application_id = appID;
    payload.template_name = templateName;
  }

  APIClient.post(`/messages`, payload).then((resp: any) => {
    dispatch(
      pendingMessageSendSuccess(appID, {
        job: resp.job,
        message: {
          message,
          document_ids: docIDs,
          created_at: new Date(),
          read_by_borrower: true,
          read_by_operator: true,
          read: true,
        },
      }),
    );
  });
};

export const sendMessageAsBorrower = (appID: number, message: string, docIDs: string[]) =>
  sendMessage(appID, message, docIDs, null, false);

export const sendMessageAsOperator = (
  appID: number,
  message: string,
  docIDs: string[],
  templateName: string,
) => sendMessage(appID, message, docIDs, templateName, true);

export const loadMessages = (applicationID: number) => dispatch => {
  APIClient.get(`/messages/${applicationID}`).then((resp: any) => {
    dispatch(messageLoadSuccess(applicationID, resp.messages));
  });
};

export const loadMessageTemplate = (applicationID: number, template_name: string) => dispatch => {
  APIClient.get(`/uw/message_templates/${template_name}/loan_applications/${applicationID}`)
    .then((resp: any) => {
      dispatch(messageTemplateLoadSuccess(applicationID, resp.filled_text, template_name));
    })
    .catch((err: any) => {
      // A 422 indicates missing template vars (422 - Unprocessable Entity)
      if (err && err.meta && err.meta.code === 422) {
        dispatch(
          messageTemplateLoadError(
            applicationID,
            err.meta.error_detail,
            err.response.missing_fields,
          ),
        );
      } else {
        dispatch(messageTemplateLoadError(applicationID, err.meta.error_detail, []));
      }
    });
};

export const getUnreadMessageCount = (applicationID: number) => dispatch => {
  APIClient.get(`/${applicationID}/messages/unread`).then((resp: any) => {
    dispatch(messageUnreadCountSuccess(applicationID, resp.unread));
  });
};

export const markMessageAsRead = (applicationID: number, messageID: number) => dispatch => {
  APIClient.post(`/${applicationID}/messages/${messageID}/read`, {}).then((resp: any) => {
    dispatch(messageReadSuccess(applicationID, resp.record));
    dispatch(getUnreadMessageCount(applicationID));
  });
};

export const markMessageAsUnread = (applicationID: number, messageID: number) => dispatch => {
  APIClient.post(`/uw/${applicationID}/messages/${messageID}/unread`, {}).then((resp: any) => {
    dispatch(messageUnreadSuccess(applicationID, resp.messageUnread));
    dispatch(getUnreadMessageCount(applicationID));
  });
};

export const deletePendingMessage = (applicationID: number, jobID: number) => dispatch => {
  APIClient.deleteRequest(`/${applicationID}/messages/${jobID}`).then((resp: any) => {
    dispatch(pendingMessageDeletedSuccess(applicationID, jobID));
  });
};
